<template>
    <div class="coach-required">
        <div class="coach-required__icon">
            <v-icon size="26" color="txtMuted">mdi-account-search-outline</v-icon>
        </div>
        <div class="coach-required__title">{{ $t('common.no_selected_coach_title') }}</div>
        <p class="coach-required__text">{{ $t('common.no_selected_coach') }}</p>
        <v-btn class="coach-required__btn" depressed @click="selectCoach">
            <v-icon size="17" class="mr-2">mdi-account-cog</v-icon>
            {{ $t('common.select_coach') }}
        </v-btn>
    </div>
</template>

<script>
import { EventBus } from '@/utils/EventBus'

export default {
    name: "CoachRequired",
    methods: {
        selectCoach() {
            EventBus.$emit('company:select-coach')
        },
    },
}
</script>

<style scoped>
.coach-required {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 10px;
    padding: 64px 20px;
}

.coach-required__icon {
    width: 52px;
    height: 52px;
    border-radius: 14px;
    background: var(--v-surface2-base);
    border: 1px solid var(--v-outline-base);
    display: flex;
    align-items: center;
    justify-content: center;
}

.coach-required__title {
    font-size: var(--fs-title);
    font-weight: 700;
    color: var(--v-txtPrimary-base);
}

.coach-required__text {
    margin: 0;
    max-width: 380px;
    font-size: var(--fs-body);
    color: var(--v-txtMuted-base);
}

.coach-required__btn {
    margin-top: 6px;
    height: 38px !important;
    border-radius: 10px !important;
    text-transform: none;
    letter-spacing: 0;
    font-weight: 600;
    background: var(--brand-gradient) !important;
    color: #0C0E12 !important;
}
</style>
